"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getCurrency = void 0;
var getCurrency = function () { return (exports.websiteConfig && exports.websiteConfig.currency) || 'EUR'; };
exports.getCurrency = getCurrency;
